import * as Sentry from '@sentry/react';

export const initializeSentry = () => {
    if (process.env.NODE_ENV === 'production') {
        Sentry.init({ dsn: process.env.REACT_APP_SENTRY_DSN });
    }
};
